import React from "react";
import LocalNavbar from "../components/localnavbar";
import "../styles/serverapi.css";

const ServerAPIs = () => {
  const projects = [
    {
      name: "Template Microservice",
      description:
        "A foundational microservice within the distributed notification system, providing a reusable scaffold for services like email, push, and API gateway, with built-in logging, configuration, and health checks",
      Docs: "https://github.com/merytpeters/notification-system/tree/main/template-service",
      technologies: ["FastAPI", "PostgreSQL", "XATA", "Redis"],
    },
    {
      name: "HNG 2025",
      description: "Backend Track of my Journey in HNG",
      Docs: "https://hng-2025-cooz.onrender.com/docs",
      technologies: ["FastAPI", "PostgreSQL"],
    },
    {
      name: "Wallet Service",
      description:
        "A secure wallet and payment API that supports user authentication, deposits, transaction tracking, and real-time Paystack payment processing via webhooks.",
      Docs: "https://hng-2025-cooz.onrender.com/wallet-service/docs",
      technologies: ["FastAPI", "PostgreSQL"],
    },
    {
      name: "AI Document Extractor & Summarization",
      description:
        "A document processing service that stores uploaded files, extracts text, and generates AI-powered summaries for quick insights. Live storage uses PostgreSQL, locally minio bucket can be setup",
      Docs: "https://hng-2025-cooz.onrender.com/documents/docs",
      technologies: ["FastAPI", "PostgreSQL", "minio"],
    },
  ];

  return (
    <div className="apipage">
      <div className="apicontainer">
        <LocalNavbar />
        <ul>
          {projects.map((project, index) => (
            <li className="api-card" key={index}>
              <h3>{project.name}</h3>

              {project.description && <p>{project.description}</p>}

              {project.imgSrc && (
                <img src={project.imgSrc} alt={project.name} />
              )}

              {project.technologies && project.technologies.length > 0 && (
                <p>Tech Used: {project.technologies.join(", ")}</p>
              )}

              {project.Docs && (
                <p>
                  <a
                    href={project.Docs}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Documentation
                  </a>
                </p>
              )}

              {project.link && (
                <p>
                  <a
                    href={project.link}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Check it out
                  </a>
                </p>
              )}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default ServerAPIs;
